import { Typography } from "@mui/material";
import { SwiperSlide } from "swiper/react";
import { IChannel } from "../../models/channel";

import { Common } from "../../components";
import { ChannelCard } from "../../components/channel";
import { ERoute } from "../../constants";

type TOwnProps = {
  channelList: IChannel[];
};

const ChannelCarousel = (props: TOwnProps) => {
  const { channelList } = props;

  const renderChannelList = () => {
    if (channelList.length === 0)
      return (
        <Typography>There is no channel available at the moment</Typography>
      );

    return channelList.map((c, idx) => (
      <SwiperSlide key={idx} style={{ display: "flex", alignItems: "center" }}>
        <ChannelCard
          {...c}
          channelPath={c.title}
          id={c.id.toString()}
          cardImg={c.thumbnail}
          path={`/${ERoute.CHANNEL}/${c.id}`}
        />
      </SwiperSlide>
    ));
  };

  return (
    <Common.Carousel total={channelList.length || 0}>
      {renderChannelList()}
    </Common.Carousel>
  );
};

export default ChannelCarousel;
